import ApiUrls from "../../../../service/api/ApiUrls";
import StorageKeys from "../../../../const/StorageKeys";
import CacheStorage from "../../../../service/storage/CacheStorage";
import ApiService from "../../../../service/api/ApiService";
import ShowToast from "../../../../widget/common/ui/Toast";
import {
  ChatMediaGroupModel,
  ConversationMediaListGroup,
} from "../../../../model/chats/ChatMediaGroupModel";
import {
  ChatMediaModel,
  ConversationMediaList,
} from "../../../../model/chats/ChatMediaModel";

const ChatMediaProvider = new (class ChatMediaProvider {
  groupByType = (messages: ConversationMediaList[]) => {
    return messages.reduce<Record<string, ConversationMediaList[]>>(
      (acc, msg) => {
        const msgType = msg?.message_type!.toString().split(" ")[0];
        if (!acc[msgType]) acc[msgType] = [];
        acc[msgType] = [msg, ...acc[msgType]];
        return acc;
      },
      {}
    );
  };

  groupByDate = (messages: ConversationMediaList[]) => {
    return messages.reduce<Record<string, ConversationMediaList[]>>(
      (acc, msg) => {
        const date = msg?.create_date!.toString().split(" ")[0];
        if (!acc[date]) acc[date] = [];
        acc[date] = [msg, ...acc[date]];
        return acc;
      },
      {}
    );
  };

  groupByTypeDeptGroup = (messages: ConversationMediaListGroup[]) => {
    return messages.reduce<Record<string, ConversationMediaListGroup[]>>(
      (acc, msg) => {
        const msgType = msg?.message_type!.toString().split(" ")[0];
        if (!acc[msgType]) acc[msgType] = [];
        acc[msgType] = [msg, ...acc[msgType]];
        return acc;
      },
      {}
    );
  };

  groupByDateDeptGroup = (messages: ConversationMediaListGroup[]) => {
    return messages.reduce<Record<string, ConversationMediaListGroup[]>>(
      (acc, msg) => {
        const date = msg?.create_date!.toString().split(" ")[0];
        if (!acc[date]) acc[date] = [];
        acc[date] = [msg, ...acc[date]];
        return acc;
      },
      {}
    );
  };

  getMediaAPI = async (
    convId: string,
    flag: string
  ): Promise<
    Array<ConversationMediaList> | Array<ConversationMediaListGroup> | null
  > => {
    ApiUrls.init();

    const accountId: string = CacheStorage.getValue(StorageKeys.account_id);

    const url: string = `${ApiUrls.baseUrl}conversation/get_conversation_media`;
    const body: any = {
      account_id: accountId,
      conv_id: convId,
      flag: flag,
    };

    const response: any = await ApiService.postApi(url, body);
    console.log(response);
    if (response != null) {
      if (response["success"] === "1") {
        if (flag === "2" || flag === "3") {
          const chatMediaGroupModel: ChatMediaGroupModel = response;
          return chatMediaGroupModel.result?.conversation_media_list!;
        } else {
          const chatMediaModel: ChatMediaModel = response;
          return chatMediaModel.result?.conversation_media_list!;
        }
      } else {
        ShowToast.error(response["errorMessage"]);
      }
    }

    return null;
  };
})();

export default ChatMediaProvider;
